export default __webpack_public_path__ + "static/media/Deacon's Girdle of the Spilling Blood.99c1e1e1.jpg";